import React from "react";
import SwipeNav from "../../Components/SwipeNav/SwipeNav";
import OurWorkTemplate from "../../Components/OurWorkTemplate/OurWorkTemplate";
import BGPG1 from "./assets/BGPG1@2x.png";
import BGPG2 from "./assets/BGPG2@2x.png";
import BGPG3 from "./assets/BGPG3@2x.png";
import Elaine from "./assets/Elaine@2x.png";

import Cindy from "./assets/Cindy@2x.png";
import Felix from "./assets/Felix@2x.png";
import SolarInYourHometown from "./15-SolarInYourHometown";

let Components = [
  <OurWorkTemplate
    img={BGPG1}
    bottom={true}
    person={Elaine}
    copy={[
      "I am a person who is very concerned about my",
      "carbon footprint and the environment. After doing",
      "the research, I was convinced that Momentum was",
      "the company that I wanted",
    ]}
    customerName={"Elaine"}
    justifyself={"baseline"}
  />,
  <OurWorkTemplate
    img={BGPG3}
    person={Cindy}
    objectfit={"revert"}
    copy={[
      "My electricity bills for the past four",
      "months have been zero. I mean zero!",
    ]}
    justifyself={"center"}
    customerName={"Cindy"}
  />,
  <OurWorkTemplate
    img={BGPG2}
    person={Felix}
    copy={[
      "From working with the salesperson all",
      "the way through, the experience has",
      "been outstanding",
    ]}
    customerName={"Felix"}
  />,

  <SolarInYourHometown />,
];

const OurWork = () => {
  return <SwipeNav Components={Components}></SwipeNav>;
};

export default OurWork;
